import { collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from '../../utitilties/firebase';
import HomeItem from '../home/components/HomeItem';
import TherapistsModal from '../home/components/TherapistsModal';
import Modal from 'react-modal';
import Header from '../../components/Header';

const Clients = () => {

    const [clients, setClients] = useState([])
    const [therapists, setTherapists] = useState([])
    const [selectedClient, setSelectedClient] = useState(null)

    const { therapist, } = (useLocation()).state


    const getClients = async (user) => {

        const surveys = await getSurveys()

        const q = query(collection(db, "Users"), where("invitationCode", "==", therapist.invitationCode));

        const querySnapshot = await getDocs(q);
        let tempCenters = []
        querySnapshot.forEach((doc) => {
            tempCenters.push({ id: doc.id, ...doc.data(), })
        })

        console.log(tempCenters, 'ccc')
        tempCenters.forEach((user, id) => {
            surveys.forEach(survey => {
                if (survey.userId == user.id) {
                    if (survey.initialSurvey) {
                        tempCenters[id].initialCompleted = true
                    } else {
                        tempCenters[id].surveysCompleted = true
                    }
                }
            })
        })


        tempCenters.sort((a, b) => a.invitationCode - b.invitationCode)
        setClients(tempCenters)

    }

    const getTherapists = async (user) => {
        const q = query(collection(db, "PhysioTherapists"), where("centerId", "==", therapist.centerId));

        const querySnapshot = await getDocs(q);
        let tempCenters = []
        querySnapshot.forEach((doc) => {
            tempCenters.push({ id: doc.id, ...doc.data(), })
        })



        tempCenters.sort((a, b) => a.invitationCode - b.invitationCode)
        setTherapists(tempCenters)

    }


    const deleteHandler = async (id) => {
        
        let confirm = window.confirm('Are you sure want to delete client ?')
        if (confirm) {
            await deleteDoc(doc(db, "Users", id))
            setClients((clients) => clients.filter((cl) => cl.id != id))
            // getTherapists()

        }
    }

    const getSurveys = async () => {


        const q = query(collection(db, "Forms"));

        const querySnapshot = await getDocs(q);
        let tempSurveys = []
        querySnapshot.forEach((doc) => {
            tempSurveys.push({ id: doc.id, ...doc.data() })
        })



        return tempSurveys

    }

    useEffect(() => {
        if (therapist?.id) {
            getClients()
            getTherapists()
        }

    }, [therapist?.id])

    return (
        <div
            style={{
                padding: 50,
                width: "100%",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
            }}
        >
            <div>
                <Header label={`Clients - ${therapist.name}`} />
                <div
                    className='home_item'
                    style={{ marginTop: 20, backgroundColor: 'gray', color: 'white' }}
                >
                    <p style={{ width: 250 }} >{'Name'}</p>
                    <p style={{ width: 240 }} >Email</p>
                    <p style={{ width: 70 }}  >Action</p>
                    <p className='ico'   >Delete</p>
                </div>
                {
                    clients.map((client) => <HomeItem
                        clientModal
                        deleteHandler={deleteHandler}
                        center={client}
                        from='CLIENTS'
                        onMoveClick={(e) => { e.stopPropagation(); setSelectedClient(client) }}
                        therapist={therapist}
                    />)



                }
            </div>
            <Modal
                isOpen={selectedClient}
                onRequestClose={() => setSelectedClient(null)}
                style={{
                    content: {
                        top: '50%',
                        left: '20%',
                        right: 'auto',
                        bottom: 'auto',
                        transform: 'translate(-0%, -50%)',
                        width: '50%'
                    },
                    overlay: {
                        background: "#DCDCDC80",

                    }
                }}
                contentLabel="Example Modal"

            >
                <TherapistsModal
                    therapists={therapists}
                    selectedTherapist={therapist}
                    setSelectedClient={setSelectedClient}
                    selectedClient={selectedClient}
                    setClients={setClients}
                />
            </Modal>


        </div>
    )
}

export default Clients